<template>
	<tr>
		<td width="50" class="text-center pl5">{{ index + 1 }}</td>
		<td width="200" class="pl5">
			<ui-select2
				v-model="lead"
				:data="leads"
				:search="true"
				:multiple="false"
				design="mgb-0 br-default"
				item-label="name"
				size="sm"
				options-always-down
			/>
		</td>
		<td width="80" class="pl5">
			<ui-input :value="lead.id" readonly number type="tel" size="sm" />
		</td>
		<td class="pl5">
			<ui-input v-model="lead.label" type="text" size="sm" />
		</td>
		<td width="40" class="pl5" v-if="index">
			<ui-menu-card>
				<ui-button type="button" @click="removeItem(index)">Excluir</ui-button>
			</ui-menu-card>
		</td>
	</tr>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelect2 } from '@/components/ui/form'
	import { uiMenuCard } from '@/components/ui'

	import { mapActions } from 'vuex'

	export default {
		components: {
			uiButton,
			uiInput,
			uiSelect2,
			uiMenuCard,
		},

		props: {
			leads: {
				type: Array,
			},

			index: {
				type: Number,
				required: true,
			},
		},

		data() {
			return {
				lead: {
					id: null,
					name: null,
				},
			}
		},

		mounted() {
			if (!this.index && this.leads.length) {
				this.lead = Object.assign({}, this.leads[0])
				this.onChange()
			}
		},

		methods: {
			...mapActions('whatsapp', {
				removeItem: 'removeLead',
				setLead: 'setLead',
			}),

			onChange() {
				this.setLead({
					id: this.index,
					data: {
						index: this.index,
						id: this.lead.id,
						name: this.lead.name,
						label: this.lead.label,
					},
				})
			},
		},

		watch: {
			lead: {
				handler(newVal) {
					if (newVal) this.onChange()
				},

				deep: true,
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
